import { green } from '@mui/material/colors';
import React, { useEffect, useState } from 'react';
import { Card, CardBody, Progress } from 'reactstrap';
export const IProgressBar = ({ color }: any) => {
  const [value, setValue] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      if (value != 100) {
        setValue(value + 5);
      } else {
        setValue(0);
      }
    }, 500);
  }, [value]);

  return (
    <Card style={{ border: 'none' }}>
      <CardBody>
        <div>
          <Progress
            value={value}
            barStyle={{ backgroundColor: `${color}` }}
            animated
          ></Progress>
        </div>
      </CardBody>
    </Card>
  );
};
